document.addEventListener("DOMContentLoaded", function() {
    let selectedNvidia = null;

    // Selectare placă video NVIDIA
    document.querySelectorAll(".nvidia-card").forEach(card => {
        card.addEventListener("click", function() {
            document.querySelectorAll(".nvidia-card").forEach(c => c.classList.remove("selected"));
            this.classList.add("selected");

            selectedNvidia = this.getAttribute("data-id");
            let selectedNvidiaName = this.querySelector(".product-name").textContent;
            
            document.getElementById("extra-nvidia-id").value = selectedNvidia;
            document.getElementById("extra-nvidia-name").value = selectedNvidiaName;
        });
    });

    // Integrare cu butonul "Adaugă în coș"
    let addToCartButton = document.querySelector("form[action='/cart/add'] button[type='submit']");
    
    if (addToCartButton) {
        addToCartButton.addEventListener("click", function(event) {
            event.preventDefault(); // Oprește acțiunea normală a butonului

            let form = this.closest("form");
            form.submit(); // Trimite formularul cu datele actualizate
        });
    }
});
